import FullPagePaginationControls from "../react_components/full_page_pagination_controls";

export const WorkEditionsComponents = {
  FullPagePaginationControls,
};
